import { GraphQLQueryClass, TLate } from "@harea/component";

export class LateQuery implements GraphQLQueryClass<TLate, TResponse> {
  public queryKey: string = "App.harea.late";

  public gql: string = `
    query LateQuery($id: Float) {
        late(filter: { id: $id }) {
            id
            lateDate
            actualStartArrival
            timeDelay
            reason
            payrollDeductionAmount
            employee {
                id
                fullName
            }
            createdAt
        }
    }
  `;
  variables?: any;
  constructor(variables?: any) {
    this.variables = variables;
  }
  mapFn(data: TResponse): TLate {
    return data.late;
  }
}

export type TResponse = {
  late: TLate;
};
